/** Where Tab goes inside an open panel: round at either end, and in from
 *  outside, so the page behind never takes focus. Null leaves the browser's step. */
export function trapStep<T>(items: readonly T[], active: T | null, back: boolean): T | null {
  if (items.length === 0) return null
  const i = active === null ? -1 : items.indexOf(active)
  const last = items[items.length - 1]!
  if (i === -1) return back ? last : items[0]!
  if (back && i === 0) return last
  if (!back && i === items.length - 1) return items[0]!
  return null
}

export const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
